import { render, staticRenderFns } from "./NodeCard.vue?vue&type=template&id=1bda39ec&scoped=true"
import script from "./NodeCard.vue?vue&type=script&lang=js"
export * from "./NodeCard.vue?vue&type=script&lang=js"
import style0 from "./NodeCard.vue?vue&type=style&index=0&id=1bda39ec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bda39ec",
  null
  
)

export default component.exports